import React, { useState, useEffect } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { LiaShoppingBagSolid } from "react-icons/lia";
import order_pkg from "../assets/images/order-pkg.png";
import ApiService from "../services/ApiService";
import PageLoader from "../components/PageLoader";
import {formatDate} from "../utils/helper";
import {statusColor} from "../utils/statusColors";
import { toast } from "react-toastify";
import moment from 'moment';
import Header from "../components/Header";
import PaymentSection from "../components/PaymentSection";

const DetailPage = () => {

    const [order, setOrder] = useState([]);
    const [order_title, setOrderTitle] = useState("");
    const [isLoader, setIsLoader] = useState(false);
    const { id } = useParams();
    const { pathname } = useLocation();

    // Payment states
    const [paymentMethod, setPaymentMethod] = useState('');
    const [cards, setCards] = useState([]);
    const [cardId, setCardId] = useState('');
    const [isPaying, setIsPaying] = useState(false);
  
    useEffect(() => {
      window.scrollTo(0, 0);
      getOrderDetails();
      
      // Check for selected card from AddCard page
      const selectedCardId = localStorage.getItem('selected_card_id');
      if (selectedCardId) {
        setPaymentMethod('Card');
        setCardId(selectedCardId);
      }
      getCards();
    }, [pathname]);

    const getCards = async () => {
      try {
        const response = await ApiService.request({
          method: "GET",
          url: "/getCustomerCards",
        });
        const data = response.data;
  
        if (data.status) {
          setCards(data.data?.cards);
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    };

    const removeCard = async (deletedCardId, showConfirmation = true) => {
      try {
        if (showConfirmation && !window.confirm('Are you sure you want to delete this card?')) {
          return;
        }
        
        setIsLoader(true);
        const response = await ApiService.request({
          method: "POST",
          url: "/deleteCard",
          data: { cardId: deletedCardId }
        });
        const data = response.data;
  
        if (data.status) {
          if (showConfirmation) {
            toast.success("Card deleted successfully");
          }
          getCards();
          if (cardId === deletedCardId) {
            setCardId('');
            localStorage.removeItem('selected_card_id');
            setPaymentMethod('COD'); // Default back to COD/COP
          }
        } else {
          if (showConfirmation) {
            toast.error(data.message);
          }
        }
      } catch (error) {
        console.error("API Error:", error);
        if (showConfirmation) {
          toast.error("Failed to delete card");
        }
      } finally {
        setIsLoader(false);
      }
    };
  
    const getOrderDetails = async () => {
      try {
        setIsLoader(true);
        const response = await ApiService.request({
          method: "GET",
          url: "/getOrderDetails",
          data: {order_id:id}
        });
        const data = response.data;
  
        if (data.status) {
          setOrder(data.data?.order);
          setOrderTitle(data.data?.order_title);
          if (!paymentMethod) {
             setPaymentMethod(data.data?.order?.payment_method || 'COD');
          }
          if (data.data?.order?.payment_status !== 'Paid') {
            window.scrollTo(0, document.getElementById('pay_now').offsetTop);
          }
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        setIsLoader(false);
      }
    };

    const handlePayNow = async () => {
      try {
        setIsPaying(true);
        
        // Handle Card Payment
        if (paymentMethod === 'Card') {
            if (!cardId) {
                toast.error("Please select a card");
                setIsPaying(false);
                return;
            }

            const response = await ApiService.request({
                method: "POST",
                url: "/makePayment",
                data: { cardId, amount: order.grand_total, order_id: order._id },
            });

            if (response.data.status) {
                toast.success("Payment successful!");
                // Remove card if one-time use (logic from Checkout)
                const saveForFuture = localStorage.getItem('save_for_future') || 'false';
                const selectedCardId = localStorage.getItem('selected_card_id');
                if (saveForFuture === 'false' && selectedCardId) {
                    await removeCard(selectedCardId, false);
                }
                localStorage.removeItem('selected_card_id');
                localStorage.removeItem('save_for_future');
                
                getOrderDetails(); // Refresh to show Paid status
            } else {
                toast.error(response.data.message || "Payment failed");
            }
        } else {
            // Handle COD/COP update
            // Check if method actually changed
            if (paymentMethod !== order.payment_method) {
                const response = await ApiService.request({
                    method: "POST",
                    url: "/updateOrderPaymentMethod",
                    data: { order_id: order._id, payment_method: paymentMethod }
                });
                
                if (response.data.status) {
                    toast.success("Payment method updated successfully");
                    getOrderDetails();
                } else {
                    toast.error(response.data.message || "Failed to update payment method");
                }
            } else {
                toast.info("Payment method is already set to " + paymentMethod);
            }
        }

      } catch (error) {
        console.error("Payment Error:", error);
        toast.error("An error occurred during payment");
      } finally {
        setIsPaying(false);
      }
    };


  return (
    <>
      {isLoader ?(
            <PageLoader />
          ):(
          <div className="main-heading container">
            
            <Header title={'Order Details'} back={'/my-orders'} />
            

            <div className="pkg-bar d-flex justify-content-between p-4 rounded-4 mx-3 shadow">
              <p className="fw-bold">
                {order.status == "Cancelled" || order.status == "Delivered" ?(
                  <div className="">
                    Order is {order.status}
                  </div>
                ):(
                  <div className="">
                      Estimated {order.type} time <br />
                      <span className="fw-light"> {formatDate(order?.createdAt,'hh:mm A')} - {moment(order?.createdAt).add(order?.branch?.delivery_time, 'minutes').format('hh:mm A')}</span>
                  </div>

                )}
                
              </p>
              <img src={order_pkg} />
            </div>
            <div className="circle"></div>

            <div className="order-details p-4">
              <div className="d-flex justify-content-between align-items-center">
                <h5>{order_title}</h5>
                <p>Order ID {order.order_code}</p>
              </div>
              <h5>AED {order.grand_total}</h5>
              <div className="order-type bg-white rounded-3 shadow">
                <h6>Order type</h6>
                <p>{order.type}</p>
              </div>
              <div className="order-type bg-white rounded-3 shadow my-2">
                <h6>Branch Name</h6>
                <p> {order.branch?.name}</p>
              </div>
              <div className="order-type bg-white rounded-3 shadow">
                <h6>Date & Time</h6>
                <p> {formatDate(order?.createdAt,'DD MMM YYYY, hh:mm A')} </p>
              </div>
              <div className="order-type bg-white rounded-3 shadow my-2">
                <h6>Order Items</h6>
                {order.order_items && order.order_items.map((orderItem, index) => (
                  <div className="row">
                    <div className="d-flex justify-content-between align-items-center">
                      <p className="text-secondary">{orderItem.quantity}x {orderItem?.item?.title}</p>
                      <p>AED {(orderItem.item.discounted_price)?orderItem.item.discounted_price:orderItem.item.original_price}</p>
                    </div>
                      {orderItem.addons && orderItem.addons.map((addon, aIndex) => (
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="text-secondary">{addon.quantity}x {addon?.item_id?.title}</p>
                          <p>AED {addon.total_price}</p>
                        </div>
                      ))}
                  </div>
                ))}
              
              </div>
              {order?.payment_status !== 'Failed' &&
                <div className="order-type bg-white shadow rounded-3 order-list">
                  <h6>Order Status</h6>
                  <p> <span className={`badge  order-${statusColor[order.status]} rounded fw-normal ms-3 fs-6`}>
                              {order?.status}
                      </span></p>
                </div>
                }

              <div className="order-type order-stats rounded-3 my-2 border-bottom">
                <h5 className="text-success fw-normal">Subtotal</h5>
                <p>AED {order?.total_price}</p>
              </div>
              {order?.delivery_charges > 0 &&
                <div className="order-type order-stats rounded-3 border-bottom">
                  <h6 className="fw-normal text-secondary">Delivery Fee</h6>
                  <p>AED {order?.delivery_charges}</p>
                </div>
              }
              {order?.promo_code &&
                <div className="order-type order-stats rounded-3 border-bottom">
                  <h6>Promo Code ({order?.promo_code})</h6>
                  <p>AED {order?.promo_discount}</p>
                </div>
              }
              {order?.loyalty_discount > 0 &&
                <div className="order-type order-stats rounded-3 border-bottom">
                  <h6> Loyalty ( <span className={(order?.points_type=="reward")?'text-success text-capitalize':'text-danger text-capitalize'}>
                    {order?.points_type} </span> )</h6>
                  <p className={(order?.points_type=="reward")?'text-success':'text-danger'}>AED {order?.loyalty_discount}</p>
                </div>
              }
              {order?.vat_amount > 0 &&
                <div className="order-type order-stats rounded-3 border-bottom">
                  <h6 className="text-secondary fw-normal">VAT</h6>
                  <p>AED {order?.vat_amount}</p>
                </div>
              }
                <div className="order-type order-stats rounded-3 border-bottom">
                  <h5>Total Amount</h5>
                  <p className="fw-bold">AED {order?.grand_total}</p>
                </div>
              <div className="order-type order-stats rounded-3 border-bottom">
                <h5>Payment Method</h5>
                <p className="text-secondary">{order?.payment_method}</p>
              </div>
              <div className="order-type order-stats rounded-3 border-bottom order-list bg-transparent">
                <h5>Payment Status</h5>
                <p className={` order-${statusColor[order?.payment_status]}`}>{order?.payment_status}</p>
              </div>
            </div>

            {/* {order.payment_status !== 'Paid' && order.status !== 'Cancelled' && (
              <div className="bg-white rounded-4 shadow mx-3 mb-4" id="pay_now">
                 <PaymentSection
                    activeTab={order.type === 'Pickup' ? 'pickup' : 'delivery'} // Assuming order.type is 'Delivery' or 'Pickup'
                    paymentMethod={paymentMethod}
                    setPaymentMethod={setPaymentMethod}
                    cards={cards}
                    cardId={cardId}
                    setCardId={setCardId}
                    removeCard={removeCard}
                    addCardRedirect={`/add-card?goto=order/${order._id}`}
                 />
                 <div className="p-3">
                    <button 
                        className="btn btn-base w-100 py-3 rounded-3 text-white fw-bold"
                        onClick={handlePayNow}
                        disabled={isPaying || isLoader}
                    >
                        {isPaying ? 'Processing...' : (paymentMethod === 'Card' ? 'Pay Now' : 'Update Payment Method')}
                    </button>
                 </div>
              </div>
            )} */}

            <div className="d-flex justify-content-center align-items-center">
              {/* <button className="place-order-btn btn rounded btn-lg ms-3 text-white w-75">
                Re-order
              </button> */}
            </div>
          </div>
      )}
    </>
  );
};

export default DetailPage;
